;(() => {
  const initSlider = (section) => {
    let subCategorySlider, pagination

    if (document.currentScript) {
      subCategorySlider = document.currentScript.parentElement.querySelector(
        '.sub-category__slider'
      )
      if (subCategorySlider) {
        pagination = document.currentScript.parentElement.querySelector(
          '.sub-category__pagination'
        )
      }
    } else {
      subCategorySlider = section.querySelector('.sub-category__slider')
      if (subCategorySlider) {
        pagination = section.querySelector('.sub-category__pagination')
      }
    }

    if (subCategorySlider) {
      // Destroy existing swiper instance if it exists
      if (subCategorySlider.swiper) {
        subCategorySlider.swiper.destroy(true, true)
      }

      const columns = Number(subCategorySlider.dataset.columns) || 4
      
      let swiperParams = {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 24,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          750: {
            slidesPerView: Math.min(2, columns),
            slidesPerGroup: Math.min(2, columns),
          },
          990: {
            slidesPerView: Math.min(3, columns),
            slidesPerGroup: Math.min(3, columns),
          },
          1200: {
            slidesPerView: columns,
            slidesPerGroup: columns,
          },
        },
      }

      if (subCategorySlider.getAttribute('data-pagination') === 'true' && pagination) {
        swiperParams.pagination = {
          el: pagination,
          type: 'bullets',
          clickable: true,
        }
      }

      const subCategorySwiper = new Swiper(subCategorySlider, swiperParams)
    }
  }

  const initAllSliders = () => {
    const sections = document.querySelectorAll('.sub-category-section, .sub-category')
    sections.forEach((section) => {
      initSlider(section)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders)
  } else {
    initAllSliders()
  }

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.detail.section.querySelector('.sub-category-section, .sub-category')
      if (section) {
        setTimeout(() => {
          initSlider(section)
        }, 100)
      }
    })

    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(initAllSliders, 100)
    })
  }
})()

